import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useFormik } from 'formik';
import { Card, CardContent } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import * as Yup from 'yup';

import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import ButtonComp from '../../../components/button/index';
import { CommonConfig } from '../../../config/common-config';
import '../ultimatestyles.css';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';

export default function UpdateColleague(props) {
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const [allStates, setAllStates] = useState([]);
    const [allCorps, setAllCorps] = useState([]);
    const [AllImcs, setAllImcs] = useState([]);
    const [selectedImc, setselectedImc] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [updateStat, setUpdateStat] = useState(false);
    const [domainname, setDomainName] = useState('');
    const location = useLocation();
    const colleaguedetails = location.state.row;
    const selectedClient = colleaguedetails.tennantName;
    const addressid = location.state.row.addressId;
    // const [errormsg, setErrormsg] = useState('');
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [allCities, setAllCities] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountry, setselectedCountry] = useState(colleaguedetails.country);
    const [selectedStateId, setselectedStateId] = useState(colleaguedetails.stateId.id);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const fetchCountryData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/getCountries`, axiosConfig)
            .then((response) => {
                //console.log('THE FETCHED DATA : ', response);
                setAllCountries(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    const fetchStateData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/country/${data}/getStates`, axiosConfig)
            .then((response) => {
                //console.log('THE FETCHED DATA : ', response);
                setAllStates(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    const fetchCityData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/state/${data}/getCities`, axiosConfig)
            .then((response) => {
                //console.log('THE FETCHED DATA : ', response);
                setAllCities(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    const fetchStateId = (country, state) => {
        if (usertype === 'SUPERADMIN') {
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/state-country/${selectedClient}?state=${state}&country=${country}`, '', axiosConfig)
                .then((response) => {
                    setselectedStateId(response.data.state.id);
                });
        }
        else {
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/state-country/${dbname}?state=${state}&country=${country}`, '', axiosConfig)
                .then((response) => {
                    setselectedStateId(response.data.state.id);
                });
        }
    };
    const setCountry = (e) => {
        setselectedCountry(e.target.value);
        fetchStateData(e.target.value);
    };
    const setState = (e) => {
        // setselectedState(e.target.value);
        fetchCityData(e.target.value);
        fetchStateId(selectedCountry, e.target.value);
    };
    // const setCity = (e) => {
    //     setselectedCity(e.target.value);
    //     //  fetchCityData(e.target.value);
    // };

    const handleClose = () => {
        setShowBtnLoader(false);
    };
    const formik = useFormik({
        initialValues: {
            Name: colleaguedetails.colleagueName,
            addressLine1: colleaguedetails.addressLine1,
            addressLine2: colleaguedetails.addressLine2,
            city: colleaguedetails.city,
            state: colleaguedetails.stateId.stateName,
            pin: colleaguedetails.pinCode,
            country: colleaguedetails.country,
            corpClientId: colleaguedetails.corpClientId,
            designation: colleaguedetails.designation,
            colleagueNumber: colleaguedetails.colleagueNumber,
            colleagueEmailId: colleaguedetails.colleagueEmailId,
            tennantName: colleaguedetails.tennantName,
            isActive: colleaguedetails.isActive,
            userId: colleaguedetails.userId,
            corpColleagueId: colleaguedetails.corpColleagueId,
        },
        validationSchema: Yup.object().shape({
            Name: Yup.string()
                .label('Name')
                .required(),
            addressLine1: Yup.string().required('Please Enter your Address').max(1000, 'Max 1000 characters or less'),
            addressLine2: Yup.string().required('Please Enter your Address').max(1000, 'Max 1000 characters or less'),
            city: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a valid City')
                .required('Required Field'),
            state: Yup.string().ensure().required('State is Required'),
            country: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a valid Country')
                .required('Required Field'),
            pin: Yup.string()
                .matches(/^\d{4,6}$/, 'Enter a valid PIN')
                .required('Please enter your PinCode'),
            corpClientId: Yup.string().required('Please select'),
            designation: Yup.string().required('Please select'),
            tennantName: Yup.string().required('Please select'),
            colleagueEmailId: Yup.string()
                .matches(/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/, 'Enter Valid Email')
                .email('Invalid Email Format')
                .required('Required Field'),
        }),

        onSubmit: (values) => {
            setShowBtnLoader(true);
            const data = {
                colleagueName: values.Name,
                addressLine1: values.addressLine1,
                addressLine2: values.addressLine2,
                city: values.city,
                stateId: {
                    id: selectedStateId,
                },
                pinCode: values.pin,
                country: values.country,
                corpClientId: values.corpClientId,
                designation: values.designation,
                colleagueNumber: values.colleagueNumber,
                colleagueEmailId: values.colleagueEmailId,
                isActive: values.isActive,
                // tennantName: `${selectedImc}`,
                tennantName: values.tennantName,
                userId: values.userId,
                corpColleagueId: values.corpColleagueId,
            };

            axios
                .put(`${CommonConfig.dev.baseUrl}/api/auth/intClient-colleague`, data, axiosConfig)
                .then((response) => {
                    setShowBtnLoader(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        usertype === 'SUPERADMIN' ?
                            props.history.push({
                                pathname: '/menu/colleagueclientsitec',
                                state: { domainname }
                            })
                            :
                            props.history.push({
                                pathname: '/menu/ClientColleagueView',
                            });
                    }, 3000);
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowBtnLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        },
    });

    const setImc = (e) => {
        setselectedImc(e.target.value);
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${e.target.value}?page=0&size=600&sort=corpclientId,desc`,
                axiosConfig
            )
            .then((response) => setAllCorps(response.data.content))
            .catch((error) => { });
    };

    useEffect(() => {

        const IMCname = location.state.row.tennantName
        setDomainName(IMCname);

        // Get all states
        // axios
        //     .get(`${CommonConfig.dev.baseUrl}/api/auth/get-all-state/`)
        //     .then((response) => setAllStates(response.data))
        //     .catch((error) => {
        //     });
        let country = null;
        let state = null;
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setAllImcs(response.data.content);
                country = colleaguedetails.country;
                state = colleaguedetails.stateId.stateName;
                fetchCountryData();
                fetchStateData(country);
                fetchCityData(state);
            })
            .catch((error) => { });

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${IMCname}?page=0&size=600&sort=corpclientId,desc`, axiosConfig)
            .then((response) => setAllCorps(response.data.content))
            .catch((error) => { });
    }, [bearerToken]);

    const allCountryOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.country_name}>{data.country_name}</option>);
        return OptionList;
    };

    const allStateOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.state_name}>{data.state_name}</option>);
        return OptionList;
    };
    const allCityOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.city_name}>{data.city_name}</option>);
        return OptionList;
    };
    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    const allCorpOptions = (corpData) => {
        const OptionList = corpData.map((corp) => <option value={corp.corpclientId}>{corp.corpClientName}</option>);
        return OptionList;
    };

    const back = () => {
        usertype === 'SUPERADMIN' ?
            props.history.push({
                pathname: '/menu/colleagueclientsitec',
                state: { domainname }
            })
            :
            props.history.push({
                pathname: '/menu/ClientColleagueView',
            });
    };

    return (
        <>
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Colleague details updated successfully" />) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />) : null}

            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="clientcard">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Update Corporate Colleague</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                        Select IMC
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        disabled
                                        name="tennantName"
                                        onChange={setImc}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.tennantName}
                                    >
                                        <option value="">Select IMC</option>
                                        {allImcsOptions(AllImcs)}
                                    </Select>
                                    {formik.touched.tennantName && formik.errors.tennantName ? (
                                        <span className="itec-validationError">{formik.errors.tennantName}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="corpClientId" shrink>
                                        Select Corp
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        disabled
                                        name="corpClientId"
                                        onChange={setImc}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.corpClientId}
                                    >
                                        <option value="">Select Corp</option>
                                        {allCorpOptions(allCorps)}
                                    </Select>
                                    {formik.touched.corpClientId && formik.errors.corpClientId ? (
                                        <span className="itec-validationError">{formik.errors.corpClientId}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="Name" shrink>
                                        {' '}
                                        Name
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Name"
                                        name="Name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.Name}
                                    />
                                    {formik.touched.Name && formik.errors.Name ? (
                                        <span className="itec-validationError">{formik.errors.Name}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="addressLine1" shrink>
                                        {' '}
                                        Address line 1
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Address line 1"
                                        name="addressLine1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressLine1}
                                    />
                                    {formik.touched.addressLine1 && formik.errors.addressLine1 ? (
                                        <span className="itec-validationError">{formik.errors.addressLine1}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="addressLine2" shrink>
                                        {' '}
                                        Address line 2
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Address line 2"
                                        name="addressLine2"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressLine2}
                                    />
                                    {formik.touched.addressLine2 && formik.errors.addressLine2 ? (
                                        <span className="itec-validationError">{formik.errors.addressLine2}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="country" shrink>
                                        {' '}
                                        Country
                                    </InputLabel>
                                    <Select
                                        native
                                        onChange={(e) => {
                                            setCountry(e);
                                            formik.handleChange(e);
                                        }}
                                        name="country"
                                        className="bottom"
                                        onBlur={formik.handleBlur}
                                        value={formik.values.country}
                                    >
                                        <option value="">Select Country</option>
                                        {allCountryOptions(allCountries)}
                                    </Select>
                                    {formik.touched.country && formik.errors.country ? (
                                        <span className="itec-validationError">{formik.errors.country}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="state" shrink>
                                        {' '}
                                        State
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="state"
                                        value={formik.values.state}
                                        onChange={(e) => {
                                            setState(e);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select State</option>
                                        {allStateOptions(allStates)}
                                    </Select>
                                    {formik.touched.state && formik.errors.state ? (
                                        <span className="itec-validationError">{formik.errors.state}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="city" shrink>
                                        {' '}
                                        City
                                    </InputLabel>

                                    <Select
                                        native
                                        name="city"
                                        className="bottom"
                                        value={formik.values.city}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select City</option>
                                        {allCityOptions(allCities)}
                                    </Select>
                                    {formik.touched.city && formik.errors.city ? (
                                        <span className="itec-validationError">{formik.errors.city}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="pin" shrink>
                                        {' '}
                                        Pin
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Pin"
                                        name="pin"
                                        maxLength="6"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pin}
                                    />
                                    {formik.touched.pin && formik.errors.pin ? (
                                        <span className="itec-validationError">{formik.errors.pin}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="colleagueNumber" shrink>
                                        {' '}
                                        Phone Number
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Phone Number"
                                        name="colleagueNumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.colleagueNumber}
                                    />
                                    {formik.touched.colleagueNumber && formik.errors.colleagueNumber ? (
                                        <span className="itec-validationError">{formik.errors.colleagueNumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="colleagueEmailId" shrink>
                                        {' '}
                                        Email Id
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        disabled
                                        className="bottom"
                                        placeholder="Email Id"
                                        name="colleagueEmailId"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.colleagueEmailId}
                                    />
                                    {formik.touched.colleagueEmailId && formik.errors.colleagueEmailId ? (
                                        <span className="itec-validationError">{formik.errors.colleagueEmailId}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="designation" shrink>
                                        Role
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="designation"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.designation}
                                    >
                                        <option value="">Select Corp</option>
                                        <option value="Primary">Primary</option>
                                        <option value="Secondary">Secondary</option>
                                        <option value="POC">POC</option>
                                    </Select>
                                    {formik.touched.designation && formik.errors.designation ? (
                                        <span className="itec-validationError">{formik.errors.designation}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <div className="footer-button createemp-btnmaindiv">
                    <ul>
                        <li>
                            <ButtonComp className="intermediarybutn" title="Back" onClick={() => back()} />
                        </li>
                        <li>
                            {(showBtnLoader ? (
                                <LoaderPopUp showLoader={showBtnLoader} handleClose={handleClose} title="Please wait while we update your client" />
                            ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Update Colleague" />}
                        </li>
                    </ul>
                </div>
            </form>
        </>
    );
}
